import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../../components/icon';
import Spinner, { SPINNER_SIZE, SpinnerSVG, SpinnerText } from '../../../components/spinner';
import Typography from '../../../components/typography';
import { stylePropertiesToCss } from '../../../design-tokens/style-mixins';
import { getIconUrl, pxToRem } from '../../../design-tokens/style-utilities';
import { ANWBDefault } from '../../../design-tokens/theme';
const PADDING_RIGHT = 30;
/**
 * @deprecated
 */
export const SelectContainerStyles = ({ theme, $disabled, }) => css `
	position: relative;
	display: block;
	width: 100%;

	&::after {
		content: '';
		mask: url('${getIconUrl('chevron-down', 'ui')}') no-repeat center right;
		position: absolute;
		top: 50%;
		right: ${pxToRem(theme.spacing['300'])};
		transform: translateY(-50%);
		display: block;
		height: ${pxToRem(ICON_SIZES.sm)};
		width: ${pxToRem(ICON_SIZES.sm)};
		background-color: ${$disabled
    ? theme.colors.medium.iconInactiveOnMedium
    : theme.colors.highlight.iconInteractive};
		pointer-events: none;
	}
`;
/**
 * @deprecated
 */
export const SelectContainer = styled.div `
	${SelectContainerStyles}
`;
/**
 * @deprecated
 */
export const selectComponentStyles = ({ theme, $valid, $loading, }) => css `
	appearance: none;
	border-radius: ${pxToRem(theme.borderRadius.m)};
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.medium.borderFormField};
	background-image: none;
	background-color: ${theme.colors.blanc.bgFormField};
	height: ${pxToRem(Number(theme.spacing['200']) * 2 +
    Number(theme.typography.formFields['100FieldHintText'].lineHeight))};
	padding-left: ${pxToRem(theme.spacing['200'])};
	padding-right: ${pxToRem(PADDING_RIGHT)};
	text-overflow: ellipsis;
	width: 100%;

	/* This overwrite is necessary because of styling in form.styled that sets margin on all LabelTitle components within forms. */
	&&& {
		margin-top: 0;
	}

	&[aria-disabled='true'] {
		background-color: ${theme.colors.extralight.bgFormFieldDisabled};
		border-color: ${theme.colors.light.borderFormFieldDisabled};
	}

	/* Styles for Select placeholder. Select has to be required with fallback for browsers that support css:has */
	:invalid,
	:has(option[value='']:checked) {
		color: ${theme.colors.informative.textFormField};

		${stylePropertiesToCss(Object.assign(Object.assign({}, theme.typography.formFields['100FieldHintText']), { fontStyle: theme.name === ANWBDefault.name ? 'Italic' : 'Normal' }))}
	}

	${$valid === false &&
    css `
		border-color: ${theme.colors.error.borderFormField};
	`};

	${$loading === true &&
    css `
		pointer-events: none;
		padding-right: ${pxToRem(theme.spacing[600])};
	`}
`;
/**
 * @deprecated
 */
export const SelectComponent = styled(Typography).attrs({
    variant: 'field-text',
    tagName: 'select',
    'data-test': 'field-text',
}) `
	${selectComponentStyles}
`;
/**
 * Select Spinner
 * @deprecated
 */
export const selectSpinnerStyles = ({ theme }) => css `
	opacity: 1;
	position: absolute;
	top: 50%;
	right: 0;
	transform: translate(-${pxToRem(theme.spacing[200])}, -50%);

	${SpinnerSVG} {
		width: calc(${pxToRem(SPINNER_SIZE.medium)} - ${pxToRem(theme.spacing[200])});
		height: calc(${pxToRem(SPINNER_SIZE.medium)} - ${pxToRem(theme.spacing[200])});
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
/**
 * @deprecated
 */
export const SelectSpinner = styled(Spinner) `
	${selectSpinnerStyles}
`;
